import { useEffect, useState } from "react";
import PreviewTestThumbnail from "./PreviewTestThumbnail";
import toast from "react-hot-toast";
import { BASEURL } from "../../../constants";
import axios from "axios";

const NewPreviewTestComponent = ({ contentArray, setContentIndex, setPrevious,
    contentIndex, setSelectedChapterId,
    setSelectedTestId, testName, selectedTestId, question, setQuestion, questionsArray, setQuestionsArray, setIsDataSaved, setImagesArray, setCurrentQuestionId, currentQuestionId }) => {

    const [isStarted, setIsStarted] = useState(true);

    useEffect(() => {
        async function fetchOptionImageUrl(data) {
            
            const imagesPromiseArray = []
            const indexArray = []

            data.options.forEach(async (optionObject, index) => {
                
                if (optionObject.imageKey) {
                    const imagePromise = axios.get(`${BASEURL}/api/get-image`, {
                        params: {
                            imageId: optionObject.imageKey,
                            index: index
                        }
                    })
                    imagesPromiseArray.push(imagePromise)
                    indexArray.push(index)
                }

            })
         
            const promiseResponse = await Promise.all(imagesPromiseArray)
            promiseResponse.map((resObj, index) => {
                // { options : [ { image: url }]}
                const replaceIndex = indexArray[index]
                data.options[replaceIndex] = { ...data.options[replaceIndex], image: resObj.data.dataUrl }
            })
           
            setQuestion(data);
        }
        
        if (question) {

            fetchOptionImageUrl(question)

        } else {

            setQuestion({...question,
                text: '',
                // options: ['', '', '', ''],
                options: [{ id: 1, text: "", image: null, imageKey: "" }, { id: 2, text: "", image: null, imageKey: "" }, { id: 3, text: "", image: null, imageKey: "" }, { id: 4, text: "", image: null, imageKey: "" }],
                correct_answer: [],
                answer_type: 'single',
                imageData: null,
                imageKey:""
            });
        }
    }, []);
    

    const handleOnChange = (index) => {
    
        const isCorrect = question.correctAnswer.some((item) => item.value === index + 1 && item.checked);
      
        if (isCorrect) {
          toast.success("Correct answer !!");
        } else {
          toast.error("Incorrect answer !!");
        }
      };

    const disableStyle = {
        pointerEvents: "none",
        color: "grey"
    }

    function disablePrevious() {
        if (questionsArray[0].id === currentQuestionId) {
            return disableStyle;
        }
    }

    function disableNext() {
        if (questionsArray[questionsArray.length - 1].id === currentQuestionId) {
            return disableStyle
        }
    }

    function previousQuestion() {
        const currentQuestionsIndex = questionsArray.findIndex(question => question.id === currentQuestionId);
        const previousQuestion = questionsArray[currentQuestionsIndex - 1];
        setQuestion(previousQuestion);
        setCurrentQuestionId(previousQuestion.id)
    }

    function nextQuestion() {
        const currentQuestionsIndex = questionsArray.findIndex(question => question.id === currentQuestionId);
        const nextQuestion = questionsArray[currentQuestionsIndex + 1];
        setQuestion(nextQuestion);
        setCurrentQuestionId(nextQuestion.id)
    }


    function disableJumpNext() {
        //contentArray 
        //contentIndex
        if ((contentArray.length - 1) === contentIndex) {
            //on the last contentObject disable it
            return disableStyle;
        } else {
            return {}
        }
    }

    function disableJumpBack() {
        if (contentIndex === 0) {
            return disableStyle;
        } else {
            return {}
        }
    }
    function nextContent() {
        //contentArray 
        //contentIndex
        console.log('contentArray', contentArray);
        const nextContent = contentArray[contentIndex + 1];
        console.log('next content', nextContent, contentArray, contentIndex);
        if (nextContent.type === 'slide-group') {
            setSelectedChapterId(nextContent.id);
            setSelectedTestId(null);
            setContentIndex(contentIndex + 1)
        }
        if (nextContent.type === 'test') {
            setSelectedTestId(nextContent.id);
            setSelectedChapterId(null);
            setContentIndex(contentIndex + 1)
        }
    }

    function previousContent() {
        const previousContent = contentArray[contentIndex - 1];
        if (previousContent.type === 'slide-group') {
            setPrevious(true);
            setSelectedChapterId(previousContent.id);
            setSelectedTestId(null);
            setContentIndex(contentIndex - 1)
        }
        if (previousContent.type === 'test') {
            setPrevious(true);
            setSelectedTestId(previousContent.id);
            setSelectedChapterId(null);
            setContentIndex(contentIndex - 1)
        }
    }
    if (isStarted) {
            return (<>
            {
                questionsArray ? (
                    <section className="flex flex-col w-full items-center h-full px-4 overflow-auto" style={{ width: '100%' }}>
                        {/* <div className="flex items-center justify-center gap-2 pb-2">
                            <label className="text-xs">No. of questions to display during test</label> <div className="p-1 text-xs border-2 border-solid border-gray-400 rounded-lg w-12" type="number"></div>
                            <label className="text-xs">Time duration for the test</label> <div className="p-1 text-xs border-2 border-solid border-gray-400 rounded-lg w-12" type="number"></div> <span className="text-xs">Hr</span> <div className="p-1 text-xs border-2 border-solid border-gray-400 rounded-lg w-12" type="number"></div> <span className="text-xs">Min</span>
                        </div> */}
                        <div className="h-full w-full flex flex-col items-center overflow-auto py-0 relative">

                            <div className="flex gap-2 w-full p-2">
                                {/* q, currentQuestionId , setQuestion ,setCurrentQuestionId */}
                                {
                                    questionsArray.map((q, index) => {
                                        return (
                                            <PreviewTestThumbnail q={q} currentQuestionId={currentQuestionId} setQuestion={setQuestion} setCurrentQuestionId={setCurrentQuestionId} questionsArray={questionsArray} index={index} />
                                        )
                                    })
                                }
                            </div>
                            {
                                question ? (
                                    <div className="w-full flex flex-col max-w-[800px]">
                                        <div className='ql-container ql-snow'>
                                            <div className='ql-editor border' dangerouslySetInnerHTML={{ __html: question.text }}
                                            >

                                            </div>
                                        </div>
                                        {/* <div className="w-full ql-editor mb-1 border p-1 text-xs min-h-20" dangerouslySetInnerHTML={{ __html: question.text }} >
                                            {/* {question.answer_type !== 'audio' ? question.text : `Read the sentence out loud "${question.text}"`} */}
                                        {/* </div>  */}
                                        <div className="flex justify-between items-center mb-2">
                                        </div>
                                        {
                                            question?.image_data?.image ? (

                                                <div style={{ width: question.image_data.width, height: question.image_data.height }}>
                                                    <img src={question.image_data.image} style={{ height: "100%", width: "100%" }}></img>
                                                </div>

                                            ) : (null)
                                        }
                                        {
                                            question.answer_type !== 'audio' ? (
                                                <>
                                                    <section
                                                        className="text-xs flex flex-col gap-2"
                                                    // style={{
                                                    //     display: 'grid',
                                                    //     gridTemplateColumns: 'auto auto',
                                                    //     gridTemplateRows: `repeat(${Math.ceil((question.options.length) / 2)}, 80px)`,
                                                    //     gap: '1rem'
                                                    // }}
                                                    >
                                                        {
                                                            question.answer_type === 'single' ? (
                                                                question.options.map((option, optionIndex) => {
                                                                    return (
                                                                        <>
                                                                            <div className="flex h-[40px] gap-1 border border-solid border-gray-300 items-center px-2 py-0" key={optionIndex} >
                                                                                <span className="flex items-center pr-2 border-r border-solid border-gray-300 h-full text-[16px]" >{`${String.fromCharCode(65 + optionIndex)}`}</span>
                                                                                <input className="text-xl " type="radio" name={`radio${question.id}`} key={`single${optionIndex}${question.id}`} />
                                                                                <div className="w-4/5 outline-none text-xs" type="text" >{option?.text}</div>

                                                                            </div>
                                                                            {option?.image &&
                                                                                <div className="border border-solid h-24 w-24 border-gray-200">
                                                                                    <img
                                                                                        src={option?.image ? option?.image : null}
                                                                                        className={`${option?.image ? "w-28 h-full object-contain p-[2px]" : ""}`}
                                                                                    />
                                                                                </div>
                                                                            }
                                                                        </>
                                                                    )
                                                                })
                                                            ) : (
                                                                question.answer_type === 'multiple' ? (
                                                                    question.options.map((option, optionIndex) => {
                                                                        console.log('maping options ', option, question.correct_answer.includes(option));
                                                                        return (
                                                                            <>
                                                                            <div className="flex gap-1 border border-solid border-gray-300 items-center px-2 py-0 " key={optionIndex} >
                                                                                <span className="flex items-center pr-2 border-r border-solid border-gray-300 h-full text-xl text-gray-500">{`${String.fromCharCode(65 + optionIndex)}`}</span>
                                                                                <input className="text-xl" type="checkbox" name="radioCheckBox" key={`multiple${optionIndex}`} />
                                                                                <div className="w-4/5 outline-none text-xs" type="text" >{option?.text}</div>
                                                                            </div>
                                                                            {option?.image &&
                                                                                <div className="border border-solid h-24 w-24 border-gray-200">
                                                                                    <img
                                                                                        src={option?.image ? option?.image : null}
                                                                                        className={`${option?.image ? "w-28 h-full object-contain p-[2px]" : ""}`}
                                                                                    />
                                                                                </div>
                                                                            }
                                                                            </>
                                                                        )
                                                                    }
                                                                    )
                                                                ) : (
                                                                    null
                                                                    // return component for audio 
                                                                )
                                                            )
                                                        }
                                                    </section>
                                                </>
                                            ) : (null)
                                        }
                                    </div>
                                ) : (null)
                            }

                        </div>
                    </section>
                ) : (null)
            }
        </>);
    } else {
        return (
            <>
                <div className="flex h-full w-full px-4 justify-center items-center">
                    <div className="w-2/3 border rounded-md">
                        <div>
                            Test
                        </div>
                        <div>
                            Name:<span>{`${testName ? testName : ''}`}</span>
                        </div>
                        <div>
                            Duration:
                        </div>
                        <div>
                            <button onClick={() => { setIsStarted(true) }} className="border border-gray-100 bg-slate-700 text-white px-2 py-1">Start</button>
                        </div>
                    </div>
                </div>

            </>
        )
    }

}

export default NewPreviewTestComponent;